var moduleMap = {
	"./UserManagement": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ant-design_icons_es_icons_MoreOutlined_js-node_modules_ant-design_icons_-c8a9f5"), __webpack_require__.e("src_UserManagement_tsx-node_modules_moment_locale_sync_recursive_-data_image_svg_xml_base64_P-01784b")]).then(() => (() => ((__webpack_require__(/*! ./src/UserManagement */ "./src/UserManagement.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});